
export const sampleData = [
    { question: 'Another sample question text?',
        starter: 'starter question',
        Y: 's Y2 followup',
        YY: 's YY3 followup',
        YN: 's YN3 followup',
        YYY: 's YYY4 followup',
        YYN: 's YYN4 followup',
        YNY: 's YNY4 followup',
        YNN: 's YNN4 followup',
        YYYY: 'Yes YYYY5 response if not sooner',
        YYYN: 'No YYYN5 response if not sooner',
        YYNY: 'YYNY5 response if not sooner',
        YYNN: 'YYNN5 response if not sooner',
        YNYY: 'YNYY5 response if not sooner',
        YNYN: 'YNYN5 response if not sooner',
        YNNY: 'YNNY5 response if not sooner',
        YNNN: 'YNNN5 response if not sooner',

        N: 'N2 followup',
        NY: 'NY3 followup',
        NN: 'NN3 followup',
        NYY: 'NYY4 followup',
        NYN: 'NYN4 followup',
        NNY: 'NNY4 followup',
        NNN: 'NNN4 followup',
        NYYY: 'NYYY5 response if not sooner',
        NYYN: 'NYYN5 response if not sooner',
        NYNY: 'NYNY5 response if not sooner',
        NYNN: 'NYNN5 response if not sooner',
        NNYY: 'NNYY5 response if not sooner',
        NNYN: 'NNYN5 response if not sooner',
        NNNY: 'NNNY5 response if not sooner',
        NNNN: 'NNNN5 response if not sooner',
        // id: 'one'
    },
    { question: 'sample question text 2?',
        Y: 'Y2 followup',
        YY: 'YY3 followup',
        YN: 'YN3 followup',
        YYY: 'YYY4 followup',
        YYN: 'YYN4 followup',
        YNY: 'YNY4 followup',
        YNN: 'YNN4 followup',
        YYYY: 'YYYY5 response if not sooner',
        YYYN: 'YYYN5 response if not sooner',
        YYNY: 'YYNY5 response if not sooner',
        YYNN: 'YYNN5 response if not sooner',
        YNYY: 'YNYY5 response if not sooner',
        YNYN: 'YNYN5 response if not sooner',
        YNNY: 'YNNY5 response if not sooner',
        YNNN: 'YNNN5 response if not sooner',

        N: 'N2 followup',
        NY: 'NY3 followup',
        NN: 'NN3 followup',
        NYY: 'NYY4 followup',
        NYN: 'NYN4 followup',
        NNY: 'NNY4 followup',
        NNN: 'NNN4 followup',
        NYYY: 'NYYY5 response if not sooner',
        NYYN: 'NYYN5 response if not sooner',
        NYNY: 'NYNY5 response if not sooner',
        NYNN: 'NYNN5 response if not sooner',
        NNYY: 'NNYY5 response if not sooner',
        NNYN: 'NNYN5 response if not sooner',
        NNNY: 'NNNY5 response if not sooner',
        NNNN: 'NNNN5 response if not sooner',
        id: 'two'
    },
    { question: 'sample question text 3?',
        Y: 'Y2 followup',
        YY: 'YY3 followup',
        YN: 'YN3 followup',
        YYY: 'YYY4 followup',
        YYN: 'YYN4 followup',
        YNY: 'YNY4 followup',
        YNN: 'YNN4 followup',
        YYYY: 'YYYY5 response if not sooner',
        YYYN: 'YYYN5 response if not sooner',
        YYNY: 'YYNY5 response if not sooner',
        YYNN: 'YYNN5 response if not sooner',
        YNYY: 'YNYY5 response if not sooner',
        YNYN: 'YNYN5 response if not sooner',
        YNNY: 'YNNY5 response if not sooner',
        YNNN: 'YNNN5 response if not sooner',

        N: 'N2 followup',
        NY: 'NY3 followup',
        NN: 'NN3 followup',
        NYY: 'NYY4 followup',
        NYN: 'NYN4 followup',
        NNY: 'NNY4 followup',
        NNN: 'NNN4 followup',
        NYYY: 'NYYY5 response if not sooner',
        NYYN: 'NYYN5 response if not sooner',
        NYNY: 'NYNY5 response if not sooner',
        NYNN: 'NYNN5 response if not sooner',
        NNYY: 'NNYY5 response if not sooner',
        NNYN: 'NNYN5 response if not sooner',
        NNNY: 'NNNY5 response if not sooner',
        NNNN: 'NNNN5 response if not sooner',
        id: 'three',
    },
    { question: 'sample question text 4?',
        Y: 'Y2 followup',
        YY: 'YY3 followup',
        YN: 'YN3 followup',
        YYY: 'YYY4 followup',
        YYN: 'YYN4 followup',
        YNY: 'YNY4 followup',
        YNN: 'YNN4 followup',
        YYYY: 'YYYY5 response if not sooner',
        YYYN: 'YYYN5 response if not sooner',
        YYNY: 'YYNY5 response if not sooner',
        YYNN: 'YYNN5 response if not sooner',
        YNYY: 'YNYY5 response if not sooner',
        YNYN: 'YNYN5 response if not sooner',
        YNNY: 'YNNY5 response if not sooner',
        YNNN: 'YNNN5 response if not sooner',

        N: 'N2 followup',
        NY: 'NY3 followup',
        NN: 'NN3 followup',
        NYY: 'NYY4 followup',
        NYN: 'NYN4 followup',
        NNY: 'NNY4 followup',
        NNN: 'NNN4 followup',
        NYYY: 'NYYY5 response if not sooner',
        NYYN: 'NYYN5 response if not sooner',
        NYNY: 'NYNY5 response if not sooner',
        NYNN: 'NYNN5 response if not sooner',
        NNYY: 'NNYY5 response if not sooner',
        NNYN: 'NNYN5 response if not sooner',
        NNNY: 'NNNY5 response if not sooner',
        NNNN: 'NNNN5 response if not sooner',
        id: 'four'
    }
] 